module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/education-form/edu-detail/edu-detail.component.css
// module id = ./src/app/main/content/education-form/edu-detail/edu-detail.component.css
// module chunks = main